// extracted by mini-css-extract-plugin
export default {"roomsceneListContainer":"RoomSceneList_roomsceneListContainer__lJMKk","roomsceneList":"RoomSceneList_roomsceneList__mRiH3"};